var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.875 36.5C28.54 36.5 36.375 28.665 36.375 19C36.375 9.33502 28.54 1.5 18.875 1.5C9.21002 1.5 1.375 9.33502 1.375 19C1.375 28.665 9.21002 36.5 18.875 36.5Z",
    stroke: "#EDFFED",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8587 15.4671C15.678 15.4671 16.3422 14.8029 16.3422 13.9835C16.3422 13.1642 15.678 12.5 14.8587 12.5C14.0393 12.5 13.3751 13.1642 13.3751 13.9835C13.3751 14.8029 14.0393 15.4671 14.8587 15.4671Z",
    fill: "#EDFFED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0948 16.458H13.6223C13.4858 16.458 13.375 16.5688 13.375 16.7053V24.123C13.375 24.2595 13.4858 24.3703 13.6223 24.3703H16.0948C16.2313 24.3703 16.3421 24.2595 16.3421 24.123V16.7053C16.3421 16.5688 16.2313 16.458 16.0948 16.458Z",
    fill: "#EDFFED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.463 16.0464C22.4063 15.6844 21.0844 16.0024 20.2917 16.5726C20.2645 16.4662 20.1676 16.3871 20.0524 16.3871H17.5798C17.4433 16.3871 17.3325 16.4979 17.3325 16.6344V24.0521C17.3325 24.1886 17.4433 24.2994 17.5798 24.2994H20.0524C20.1888 24.2994 20.2996 24.1886 20.2996 24.0521V18.7212C20.6992 18.3771 21.214 18.2673 21.6353 18.4463C22.0438 18.6189 22.2777 19.0402 22.2777 19.6015V24.0521C22.2777 24.1886 22.3885 24.2994 22.5249 24.2994H24.9975C25.134 24.2994 25.2448 24.1886 25.2448 24.0521V19.1035C25.2166 17.0715 24.2607 16.3194 23.463 16.0464Z",
    fill: "#EDFFED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.a8817305160f12cac7dc104b8279ed4f.svg";
export { ForwardRef as ReactComponent };